import React from 'react';
import PropTypes from 'prop-types';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMMessageTimestampView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      message: this.props.message,
    };
  }
  
  render() {
    return (
      <p className="dashboard-message__date">{SMFormatHelper.relativeTime(this.state.message.created_at)}</p>
    );
  }
}

SMMessageTimestampView.propTypes = {
  message: PropTypes.object.isRequired,
};
export default SMMessageTimestampView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageTimestampView.jsx